import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { BrandStatement } from "@/components/BrandStatement";
import { FounderTeaser } from "@/components/FounderTeaser";
import { MochaStory } from "@/components/MochaStory";
import { BrandWorld } from "@/components/BrandWorld";
import { Lineup } from "@/components/Lineup";
import { JournalPreview } from "@/components/JournalPreview";
import { Waitlist } from "@/components/Waitlist";

export default function LandingPage() {
  const scrollToWaitlist = () => {
    const el = document.getElementById("waitlist");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <main data-testid="landing-page" className="bg-[#EFE8DC] text-[#2C241E] overflow-x-clip">
      <Hero onJoin={scrollToWaitlist} />
      <Marquee />
      <BrandStatement />
      <FounderTeaser />
      <MochaStory />
      <BrandWorld />
      <Lineup />
      <JournalPreview />
      <Waitlist selection={null} />
    </main>
  );
}
